import { useState, useEffect } from 'react';
import { Message } from './useAuthForm';

export function useHashError() {
  const [hashMessage, setHashMessage] = useState<Message>(null);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash.startsWith('#error=')) {
      const params = new URLSearchParams(hash.substring(1));
      const errorDescription = params.get('error_description');
      if (errorDescription) {
        setHashMessage({
          text: decodeURIComponent(errorDescription).replace(/\+/g, ' '),
          type: 'warn',
        });
        // Clean up the URL without triggering a re-render
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
      }
    }
  }, []); // Run once on mount

  return hashMessage;
}
